import React from 'react';
import './AdditionalInfo.css';

function AdditionalInfoEn() {
  return (
    <section className="additional-info-section">
      <div className="container">
        <div className="additional-info-content">
          <h2 className="additional-info-heading">We invest with vision, we diversify with criteria</h2>
          <p className="additional-info-paragraph">
            Tabia Group is an independent business holding company whose main objective is value creation through diversified investment. We manage our capital with a long-term strategic vision, investing in sectors with high growth potential and the ability to generate recurring returns.
          </p>
          <p className="additional-info-paragraph">
            Our strategy is based on intelligent risk diversification, allocating resources to different areas of activity such as real estate, technology, hospitality and other strategic businesses, both nationally and internationally. This structure allows us to balance economic cycles, take advantage of cross-cutting opportunities and build solid and resilient portfolios.
          </p>
          <p className="additional-info-paragraph">
            At Tabia Group we do not invest opportunistically: we analyze, structure and accompany each investment, actively participating in its development and management. Our approach combines financial discipline, sector knowledge and a deep understanding of the market, with the objective of maximizing long-term value and protecting invested capital.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AdditionalInfoEn;
